import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'

// Modules
import app from './modules/app'

pathify.options.deep = 2

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [pathify.plugin],
  modules: {
    app
  }
})
